import {
  GET_ORDER_SUCCESS,
  GET_ORDER_ERROR,
  GET_ORDER_DETAIL_SUCCESS,
  GET_ORDER_DETAIL_ERROR,
} from "./actionTypes";
import api from "../../api";

export const getOrderStatusData = ({ orderNumber, token }) => {
  return async (dispatch) => {
    try {
      const { data } = await api.get("orderTracking.php", {
        params: { order_number: orderNumber, token: token },
      });
      dispatch({
        type: GET_ORDER_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_ORDER_ERROR,
        payload: error,
      });
    }
  };
};

export const getOrderDetail = (locationParams) => {
  return async (dispatch) => {
    try {
      const { data } = await api.get("orderTracking.php", {
        params: (() => {
          const searchParams = new URLSearchParams(locationParams);
          return {
            order_number: searchParams.get("order_number"),
            order_pass: searchParams.get("order_pass"),
          };
        })(),
      });
      dispatch({
        type: GET_ORDER_DETAIL_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_ORDER_DETAIL_ERROR,
        payload: error,
      });
    }
  };
};
